module.exports = "<div class=\"blanco col-md-7\" ng-if=productsVm.thereIsDetails()> <div ng-include=\"'details-header-products'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=productsVm.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"productsVm.thereIsDetails() || productsVm.searchValue\" md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/products/list/products-details.html
// module id = 686
// module chunks = 0